import * as React from "react";
import $ from "jquery";
import { connect } from "react-redux";
import { AppState } from "../../../../redux";
import { Toaster } from "../../../page-framework/toaster";
import * as Actions from "../../../../redux/actions";
import {
  CreateNotificationRequestPayload,
  CreateNotificationRequestAction,
  GetNotificationSubscriptionStatusPayload,
  GetNotificationSubscriptionStatusAction,
} from "../../../../redux/notification/types";
import { RdvButton } from "../../../page-framework/rdv-button";
import isEmpty from "lodash.isempty";
import { Entity } from "@radivision/graphql/lib/ts/graphql/entity";
import { TOAST_ALERT } from "../../../../redux/toast/constants";
import { SetToastMessagePayload, SetToastMessageAction } from "../../../../redux/toast/types";

interface MapDispatchProps {
  createNotificationRequest: (payload: CreateNotificationRequestPayload) => CreateNotificationRequestAction;
  setToastMessage: (payload: SetToastMessagePayload) => SetToastMessageAction;
  getNotificationSubscriptionStatus: (
    payload: GetNotificationSubscriptionStatusPayload,
  ) => GetNotificationSubscriptionStatusAction;
}

interface ComponentProps {
  entity: Entity;
}

interface MapStateProps {
  isLoading: boolean;
  subscriptionStatus: string;
}

interface State {
  email: string | null;
  name: string | null;
  successMsg: boolean;
  errorMsg: null | string;
}

type Props = ComponentProps & MapDispatchProps & MapStateProps;

class Component extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { email: null, name: null, successMsg: false, errorMsg: null };
  }

  static getDerivedStateFromProps(props: Props, state: State) {
    if (!isEmpty(props.subscriptionStatus) && state.email === null) {
      return {
        email: props.subscriptionStatus,
      };
    }
    return null;
  }

  componentDidMount() {
    if (typeof this.props.subscriptionStatus === "undefined") {
      const { entity } = this.props;
      const notificationKind = "INVESTMENT";
      this.props.getNotificationSubscriptionStatus({ notificationKind, entityId: entity.id });
    }
    if (!isEmpty(this.props.subscriptionStatus)) {
      this.setState({ email: this.props.subscriptionStatus });
    }
  }

  onSubmit() {
    const { email, name } = this.state;
    const { entity } = this.props;
    const meta = {
      entity: entity.id,
      date: new Date().toISOString(),
      person: name,
    };
    const isValidEmail = /.+@.+\..+/g.test(email);
    if (isEmpty(name)) {
      this.props.setToastMessage({ msg: `Please enter your name`, type: TOAST_ALERT });
      return;
    }
    if (!isValidEmail) {
      this.props.setToastMessage({ msg: `Please enter a valid email address`, type: TOAST_ALERT });
      return;
    }
    this.props.createNotificationRequest({ notificationKind: "INVESTMENT", email, meta });
  }

  render() {
    const { successMsg, errorMsg, email, name } = this.state;
    const isSubscribed = !isEmpty(this.props.subscriptionStatus) && email === this.props.subscriptionStatus;
    const { entity } = this.props;

    if (isEmpty(entity)) {
      return null;
    }

    return (
      <Container>
        <form>
          <input
            type="text"
            name="name"
            value={isEmpty(name) ? "" : name}
            className="notify-me-text-input"
            onChange={(e) => {
              this.setState({ name: e.target.value });
            }}
            placeholder="First and last name"
          />
          <input
            type="text"
            name="email"
            value={isEmpty(email) ? "" : email}
            className={`notify-me-text-input ${errorMsg ? "has-error" : ""}`}
            onChange={(e) => {
              const email = e.target.value;
              this.setState({ email });
            }}
            disabled={successMsg}
            placeholder="Email"
          />
          <div className="error-message">{errorMsg}</div>
        </form>
        {isSubscribed && (
          <div className="already-subscribed">
            "{this.props.subscriptionStatus}" email address is subscribed to receive notification.
          </div>
        )}
        <RdvButton
          text="Notify Me"
          disabled={isSubscribed}
          onClick={this.onSubmit.bind(this)}
          isLoading={this.props.isLoading}
        />
      </Container>
    );
  }
}

const Container = ({ children }) => {
  return <div className="notify-me-form centered">{children}</div>;
};

const mapState = (state: AppState, props: ComponentProps) => {
  const subscriptionStatus = state.notification.status[`INVESTMENT-${props.entity?.id}`];
  return {
    subscriptionStatus,
    isLoading: state.notification.isLoading,
  };
};

const mapDispatch = {
  createNotificationRequest: Actions.createNotificationRequest,
  getNotificationSubscriptionStatus: Actions.getNotificationSubscriptionStatus,
  setToastMessage: Actions.setToastMessage,
};

export const NotifyMeForm = connect(mapState, mapDispatch)(Component);
